import { useContext } from "react"
import { UserContext } from "../Context/UserContext"
import { Table, Button } from "antd"
import { useHistory } from "react-router-dom"
import { ProfileContext } from "../Context/ProfileContext"

const Profile = () => {
    const history = useHistory()
    const [user] = useContext(UserContext)
    const [userProfile] = useContext(ProfileContext)

    const HandleChangePassword = () => {
        history.push("/profile/change-password")
    }

    const HandleEditProfile = () => {
        history.push("/profile/edit")
    }

    const HandleCreateProfile = () => {
        history.push("/profile/create")
    }

    const columnsUser = [
        {title: 'User Info', dataIndex: 'key', width: '250px'},{title: 'Data',dataIndex: 'value'}
    ]

    const columnsProfile = [
        {title: 'Profile Info', dataIndex: 'key', width: '250px'},{title: 'Data',dataIndex: 'value'}
    ]

    const dataUser = [
        {key: 'Username', value: `${user.username}`},
        {key: 'Email', value: `${user.email}`},
        {key: 'Password', value: <Button type="primary" size="small" onClick={HandleChangePassword}>Change Password</Button>}
    ]

    const dataProfile = [
        {key: 'Nama Depan', value: `${userProfile.firstName}` },
        {key: 'Nama Belakang', value: `${userProfile.lastName}`},
        {key: 'Alamat', value: `${userProfile.address}`},
        {key: 'Kota', value: `${userProfile.city}`},
        {key: 'Tanggal Lahir', value: `${userProfile.birthDate}`},
        {key: 'Profile', value: <Button type="primary" size="small" onClick={HandleEditProfile}>Edit Profile</Button>}
    ]

    const createProfile = [
        {key: 'Profile', value: <Button type="primary" size="small" onClick={HandleCreateProfile}>Create Profile</Button>}
    ]

    const isProfile = userProfile.userId !== undefined
    return(
        <>
        <h1>Profile</h1>
        <Table style={{marginTop: "20px"}} columns={columnsUser} dataSource={dataUser} pagination={false} bordered />

        {isProfile ? 
        <Table style={{marginTop: "20px"}} columns={columnsProfile} dataSource={dataProfile} pagination={false} />
        :
        <Table style={{marginTop: "20px"}} columns={columnsProfile} dataSource={createProfile} pagination={false} />
        }
        </>
    )
}
export default Profile